import { render, staticRenderFns } from "./notice-list.vue?vue&type=template&id=80777eca&scoped=true&"
import script from "./notice-list.vue?vue&type=script&lang=js&"
export * from "./notice-list.vue?vue&type=script&lang=js&"
import style0 from "./notice-list.vue?vue&type=style&index=0&id=80777eca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80777eca",
  null
  
)

export default component.exports